<template>
    <a-modal :title="props.tableColumnsData.full_name + '_续费联系人提现'" :confirmLoading="state.loading" centered
        :bodyStyle="{ padding: '20px' }" :width="1000" :open="true" @cancel="cancel" :maskClosable="false">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button :loading="state.loading" type="primary">确定提现</a-button>
            </a-popconfirm>
        </template>
        <!-- 申请发票记录 -->
        <a-table size="small" :loading="state.loading" style="margin-bottom: 30px" :columns="columns"
            :data-source="dataSource" :pagination="false"
            :row-selection="{ selectedRowKeys: state.selectedRowKeys, type: 'radio', onChange: onSelectChange }"
            rowKey="id">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex == 'action'"> {{ record.action_name }} </template>
                <template v-else-if="column.dataIndex === 'settlement_status'">
                    <a-tag v-if="record.settlement_status == 1" color="orange">已结算</a-tag>
                    <a-tag v-if="record.settlement_status == 2" color="green">未结算</a-tag>
                    <a-tag v-if="record.settlement_status == 3" color="red">结算中</a-tag>
                </template>

            </template>
        </a-table>
        <!-- 表单提交发票需要的内容 -->
        <a-form ref="ruleForm" :rules="rules" :model="formState" v-bind="formLayout" scrollToFirstError="true">
            <a-form-item label="收款人名称" required>
                <a-input v-model:value="formState.bank_name" placeholder="请输入账户户名" @blur="checkHaveHetong">
                </a-input>
            </a-form-item>
            <a-spin :spinning="state.nameloading">

                <div v-if="state.havehetong == 1">
                    <a-form-item label="账户银行卡号" required>
                        <a-input v-model:value="formState.bank_card_num" placeholder="请输入账户银行卡号">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="开户银行" required>
                        <a-input v-model:value="formState.bank_open_addr" placeholder="请输入开户银行">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="提现金额" name="money" required>
                        <a-input placeholder="" v-model:value="formState.money" prefix="￥" suffix="元"
                            style="width: 140px" @blur="checkAmount"></a-input>
                        <div>
                            <p>开票信息：<br />发票抬头：{{ state.fws.name }}<br />纳税人识别号：{{
                                state.fws.social_credit_code
                            }}<br />
                                发票金额：￥{{ formState.money }}元<br />发票备注：佣金</p>
                        </div>
                    </a-form-item>
                    <a-form-item label="发票附件" name="attachment" required>
                        <Upload :upload_path="`public/uploads/manage/财务管理/代理商提现/代理商申请/${dayjs().format('YYYYMM')}/`"
                            :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" uploadType="text"
                            v-model:value="formState.attachment" :limitation="99" uploadText="上传附件">
                        </Upload>
                    </a-form-item>
                    <a-form-item label="申请备注" name="remark ">
                        <a-textarea placeholder="" v-model:value="formState.remark" />
                    </a-form-item>
                </div>
                <div v-else-if="state.havehetong == 2">
                    <a-form-item label="合同">
                        <a-button type="primary" @click="addHetong">补充合同资料</a-button>
                    </a-form-item>
                </div>
            </a-spin>
        </a-form>
        <!-- 服务商代理合同 -->
        <FwsDailiHetong v-if="state.dailihetongVisible" @cancel="handleCancel" @ok="handleOk"
            :detailData="state.detailData">
        </FwsDailiHetong>
    </a-modal>
</template>
<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { LoadingOutlined } from '@ant-design/icons-vue'
import { reactive, onMounted, ref, computed, onUnmounted } from 'vue'
import dayjs from 'dayjs'
import Upload from '@/components/base/Upload.vue'
import FwsDailiHetong from './../../userManagement/components/createFwsDailiHetong.vue'
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})
const state = reactive<any>({
    loading: false,
    selectedRowKeys: [],
    selectedRecord: {}, //选中的order
    fws: {},//服务商开票信息
    nameloading: false,
    havehetong: 0,
    dailihetongVisible: false,
    detailData: {}
})
onMounted(() => {
    loadData()
})
//列表数据
const dataSource = ref([])
const columns: Array<Object> = [
    {
        title: '订单号',
        dataIndex: 'order_number',
        width: 250
    },
    {
        title: '可提现金额',
        dataIndex: 'seller_money',
        width: 200
    },
    {
        title: '状态',
        dataIndex: 'settlement_status',
        width: 200
    },
    {
        title: '类型',
        dataIndex: 'action',
        width: 200
    },
    {
        title: '付款时间',
        dataIndex: 'created_at',
        width: 200
    }
]
const loadData = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/sellerTixian/xftelTixianInit',
        method: 'post',
        data: { customer_id: props.tableColumnsData.id }
    }
    baseService(requestParam)
        .then((res: any) => {
            state.loading = false
            dataSource.value = res.data.list
            state.fws = res.data.fws
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('查询失败')
            }
        })
}

const onSelectChange = (selectedRowKeys: any[], val) => {
    state.selectedRowKeys = selectedRowKeys
    state.selectedRecord = val[0]
    formState.money = val[0].seller_money
}
//表单
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 14 },
        sm: { span: 14 }
    }
}
const ruleForm = ref()
const rules = []
const formState = reactive({
    money: 0, //提现金额
    bank_name: '',
    bank_card_num: '',
    bank_open_addr: '',
    attachment: [], //差额发票
    remark: '',
})
const checkAmount = () => {
    let seller_money = state.selectedRecord.seller_money ?? 0
    if (Number(formState.money) > Number(seller_money)) {
        formState.money = seller_money
    } else if (formState.money < 0) {
        formState.money = 0
    }
}
const checkHaveHetong = () => {
    if (!formState.bank_name) {
        return
    }
    state.nameloading = true
    let requestParam = {
        url: '/admin/v1/sellerTixian/xftelTixianCheck',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            bank_name: formState.bank_name
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            state.havehetong = res.data.havehetong
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.nameloading = false
        })
}

const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            if (!state.selectedRecord.id) {
                message.error('请选择提现的订单')
                return
            }
            if (formState.money <= 0 || Number(formState.money) > Number(state.selectedRecord.seller_money)) {
                message.error('请输入正确的提现金额')
                return
            }
            state.loading = true
            let requestParam = {
                url: '/admin/v1/sellerTixian/xftelTixianStore',
                method: 'post',
                data: Object.assign({ 'order_id': state.selectedRecord.id, 'customer_id': props.tableColumnsData.id }, formState)
            }
            baseService(requestParam)
                .then((res: any) => {
                    message.success('提交成功')
                    cancel()
                })
                .catch((res) => {
                    state.loading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('申请失败')
                    }
                })
        })
        .catch(() => { })
}
const cancel = () => {
    emit('cancel')
}
//补充合同资料
const addHetong = () => {
    state.dailihetongVisible = true
    state.detailData = {
        customer_id: props.tableColumnsData.id,
        company_name: formState.bank_name
    }
}
const handleCancel = () => {
    state.dailihetongVisible = false
}
const handleOk = () => {
    state.dailihetongVisible = false
    checkHaveHetong()
}
</script>
<style lang="scss" scoped></style>
